import React from 'react';
import { Star, ChevronRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Benefits = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-8 md:py-16 bg-gray-50" data-id="element-22">
      <div className="container mx-auto px-3 md:px-8" data-id="element-23">
        <div className="bg-blue-800 text-white py-2 md:py-3 px-4 md:px-6 rounded-t-lg inline-block mb-4 md:mb-8" data-id="element-24">
          <h2 className="text-base md:text-xl font-bold" data-id="element-25">
            {t('benefits.header')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-6 md:mb-12" data-id="element-26">
          {[{
          title: t('benefits.benefit1Title'),
          description: t('benefits.benefit1Desc')
        }, {
          title: t('benefits.benefit2Title'),
          description: t('benefits.benefit2Desc')
        }, {
          title: t('benefits.benefit3Title'),
          description: t('benefits.benefit3Desc')
        }, {
          title: t('benefits.benefit4Title'),
          description: t('benefits.benefit4Desc')
        }, {
          title: t('benefits.benefit5Title'),
          description: t('benefits.benefit5Desc')
        }, {
          title: t('benefits.benefit6Title'),
          description: t('benefits.benefit6Desc')
        }].map((benefit, index) => <div key={index} className="bg-white p-4 md:p-6 rounded-lg shadow-md" data-id="element-27">
              <div className="flex items-center mb-3 md:mb-4" data-id="element-28">
                <Star className="text-yellow-500 mr-2" size={20} data-id="element-29" />
                <h3 className="text-lg md:text-xl font-bold text-gray-800" data-id="element-30">
                  {benefit.title}
                </h3>
              </div>
              <p className="text-sm md:text-base text-gray-700" data-id="element-31">
                {benefit.description}
              </p>
            </div>)}
        </div>
        <div className="text-center" data-id="element-32">
          <a href="https://knovastore.com/cart/47931982774491:1" className="flex items-center justify-center mx-auto bg-green-500 hover:bg-green-600 text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-lg text-base md:text-lg transition duration-300" data-id="element-33">
            {t('benefits.cta')}
            <ChevronRight className="ml-2" size={20} data-id="element-34" />
          </a>
        </div>
      </div>
    </section>;
};